import { ISnotrRoute } from '..';

export default [
  {
    path: '/webstore-api-tokens',
    name: 'WebstoreApiTokens',
    meta: {
      title: 'TabTitle.webstoreApiTokens',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/webstore-api-tokens.vue'),
  },
] as ISnotrRoute[];
